(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lead-capture-popup"]) return;
  try {
    
  (() => {
    const day = 24 * 60 * 60 * 1000

    document.querySelectorAll('[data-bl-lead-popup]').forEach((dialog) => {
      if (dialog.dataset.blLeadReady === 'true') return
      dialog.dataset.blLeadReady = 'true'

      const form = dialog.querySelector('form')
      const statusNode = dialog.querySelector('[data-bl-lead-status]')
      const email = dialog.querySelector('[data-bl-lead-email]')
      const closeButton = dialog.querySelector('[data-bl-lead-close]')
      const applyButton = dialog.querySelector('[data-bl-lead-apply]')
      const status = statusNode ? statusNode.dataset.blLeadStatus : 'idle'
      const designMode = dialog.dataset.designMode === 'true'
      const delay = Number(dialog.dataset.delaySeconds || 30) * 1000
      const depth = Number(dialog.dataset.scrollDepth || 20)
      const dismissKey = 'black-lume-lead-popup-dismissed-until-v1'
      const successKey = 'black-lume-lead-popup-subscribed-until-v1'
      const sessionKey = 'black-lume-lead-popup-viewed-v1'
      let delayReady = false
      let scrollReady = false
      let opened = false

      const storageRead = (storage, key) => {
        try {
          return storage.getItem(key)
        } catch (error) {
          return null
        }
      }

      const storageWrite = (storage, key, value) => {
        try {
          storage.setItem(key, value)
        } catch (error) {
          return false
        }
        return true
      }

      const track = (action) => {
        document.dispatchEvent(new CustomEvent('blacklume:lead-popup', { detail: { action } }))
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: `black_lume_popup_${action}` })
        }
      }

      const openPopup = (source) => {
        if (dialog.open) return
        opened = true
        dialog.showModal()
        if (!designMode) storageWrite(window.sessionStorage, sessionKey, 'true')
        track(source === 'form-response' ? status : 'view')
        if (email && window.matchMedia('(min-width: 681px)').matches) {
          window.setTimeout(() => email.focus({ preventScroll: true }), 80)
        }
      }

      const isSuppressed = () => {
        const dismissedUntil = Number(storageRead(window.localStorage, dismissKey) || 0)
        const subscribedUntil = Number(storageRead(window.localStorage, successKey) || 0)
        const viewed = storageRead(window.sessionStorage, sessionKey) === 'true'
        return Date.now() < dismissedUntil || Date.now() < subscribedUntil || viewed
      }

      const maybeOpen = () => {
        if (opened || dialog.open || !delayReady || !scrollReady || isSuppressed()) return
        if (document.querySelector('.mobile-menu[open]')) return
        openPopup('engaged')
      }

      const updateScrollDepth = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight
        if (scrollable <= 0) return
        scrollReady = (window.scrollY / scrollable) * 100 >= depth
        maybeOpen()
        if (scrollReady) window.removeEventListener('scroll', updateScrollDepth)
      }

      const dismiss = (reason) => {
        if (!designMode) {
          const days = status === 'success' ? 180 : 7
          const key = status === 'success' ? successKey : dismissKey
          storageWrite(window.localStorage, key, String(Date.now() + days * day))
        }
        track(reason)
        dialog.close()
      }

      closeButton?.addEventListener('click', () => dismiss('close'))

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault()
        dismiss('escape')
      })

      dialog.addEventListener('click', (event) => {
        const box = dialog.getBoundingClientRect()
        const outside = event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom
        if (outside) dismiss('backdrop')
      })

      form?.addEventListener('submit', () => track('submit'))
      applyButton?.addEventListener('click', () => track('apply'))

      document.querySelectorAll('.mobile-menu').forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) maybeOpen()
        })
      })

      const formResponse = status !== 'idle' && window.location.hash === '#BlackLumeLeadCapture'

      if (formResponse) {
        if (status === 'success') {
          storageWrite(window.localStorage, successKey, String(Date.now() + 180 * day))
        }
        openPopup('form-response')
        return
      }

      if (designMode) {
        window.requestAnimationFrame(() => openPopup('theme-editor'))
        return
      }

      window.addEventListener('scroll', updateScrollDepth, { passive: true })
      updateScrollDepth()
      window.setTimeout(() => {
        delayReady = true
        maybeOpen()
      }, delay)
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
